import React from 'react'
import { motion } from 'framer-motion'
import { StarIcon } from '@heroicons/react/24/solid'

const reviews = [
  {
    name: 'Sarah Johnson',
    role: 'Teen Student',
    rating: 5,
    text: 'Amazing experience! My instructor was patient and professional. Passed my road test on the first try!',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop&crop=face',
    date: '2 weeks ago',
  },
  {
    name: 'Michael Chen',
    role: 'Adult Learner',
    rating: 5,
    text: 'As an adult learner, I was nervous to start. The team made me feel comfortable and confident behind the wheel.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
    date: '1 month ago',
  },
  {
    name: 'Emily Rodriguez',
    role: 'Parent',
    rating: 5,
    text: 'My daughter completed the teen program and is now a confident, safe driver. Highly recommend to all parents!',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face',
    date: '3 weeks ago',
  },
  {
    name: 'David Thompson',
    role: 'Teen Student',
    rating: 5,
    text: 'The instructors are amazing! They really care about your success and make learning fun. Best driving school in Virginia!',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face',
    date: '1 week ago',
  },
  {
    name: 'Lisa Anderson',
    role: 'Adult Learner',
    rating: 5,
    text: 'I was terrified of driving after a long break. The patient instruction and flexible schedule helped me regain my confidence.',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face',
    date: '2 months ago',
  },
  {
    name: 'Robert Martinez',
    role: 'Parent',
    rating: 5,
    text: 'Both of my sons went through the teen program. Excellent instruction, professional staff, and great results. Worth every penny!',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face',
    date: '1 month ago',
  },
]

export default function ReviewsContent() {
  return (
    <div className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <div className="text-accent font-heading font-semibold text-sm uppercase tracking-wider mb-2">
            Testimonials
          </div>
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-primary mb-4">
            What Our Students Say
          </h1>
          <p className="text-lg text-secondary-text max-w-2xl mx-auto">
            Don&apos;t just take our word for it - hear from our successful graduates.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {reviews.map((review, index) => (
            <motion.div
              key={review.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -5, transition: { duration: 0.2 } }}
              className="bg-white p-6 rounded-lg shadow-soft"
            >
              <div className="flex gap-1 mb-4">
                {[...Array(review.rating)].map((_, i) => (
                  <StarIcon key={i} className="w-5 h-5 text-accent" />
                ))}
              </div>
              <p className="text-secondary-text mb-6 italic">
                &quot;{review.text}&quot;
              </p>
              <div className="flex items-center gap-3">
                <div className="relative w-12 h-12 rounded-full overflow-hidden">
                  <img
                    src={review.image}
                    alt={review.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="font-heading font-semibold text-primary">
                    {review.name}
                  </div>
                  <div className="text-sm text-secondary-text">
                    {review.role}
                  </div>
                  <div className="text-xs text-secondary-text/70 mt-1">
                    {review.date}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  )
}

